import React from "react";
import PropTypes from "prop-types";
import {findDOMNode} from "react-dom";
import PopoverMenuSeparator from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator";
import PopoverMenuHeader from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-header";
import {PopoverMenuItemType} from "../../../../../gd-components/popover-menu/popover-menu/const";
import FieldMultiselect from "../../multiselect";

export default class FieldMultiselect_PopoverOptionsSelector extends React.Component<any,any> {

    public optionRef        : any

    static propTypes = {
        parent: PropTypes.object,
        field: PropTypes.object,

        searchString: PropTypes.string,

        keyboardNavigation: PropTypes.bool,

        onUpdateScroll: PropTypes.func,
    }

    static defaultProps = {
        keyboardNavigation: true
    }

    constructor(props:any) {
        super(props);

        this.state = {
            currentCursorKey: null
        };

        // references for options for keyboard navigation
        this.optionRef = {};
    }

    componentDidUpdate(prevProps:any, prevState:any, snapshot:any) {
        const node = this.optionRef[this.state.currentCursorKey] ? findDOMNode(this.optionRef[this.state.currentCursorKey]) : null;

        // scroll for cursor to be visible
        if (node) this.props.onUpdateScroll(node);
    }

    _getOptions = () => {
        let options = this.props.field.getOptions().slice();

        // filter options by search string
        let searchString = this.props.searchString;
        if (searchString) {
            searchString = searchString.toLowerCase();
            options = _(options)
                .filter(option => option.label.toLowerCase().includes(searchString))
                .value();
        }

        // add all values if necessary
        if (this.props.field.allValuesOption) {
            options.unshift({
                isAllValuesOption   : true,
                label               : this.props.field.allValuesOptionLabel
            });
        }

        return options;
    }

    onClickOption = (option: Option, e: React.MouseEvent | React.KeyboardEvent) => {
        this.props.parent.onOptionClick(option, e)
    }

    onChangeCursorOption = (newValue:any) => {
        this.setState({currentCursorKey: newValue});
    }

    onPopoverKeyDown = (event:any) => {
        if (!this.props.keyboardNavigation) return;

        const options = this._getOptions();

        let newValue;

        switch(event.key) {
            case 'Escape': this.props.parent.hidePopover(); break;

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0;
                }

                this.onChangeCursorOption(newValue);
                break;

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey + 1;
                    if (newValue > options.length - 1) newValue = options.length - 1;
                }

                this.onChangeCursorOption(newValue);
                break;

            case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey];
                    if (curOption) this.onClickOption(curOption, event);
                }
                break;
        }
    }

    render() {
        const field : FieldMultiselect = this.props.field;
        const options = this._getOptions();
        const highlightedOption = options[this.state.currentCursorKey];

        let selectedValues : any[]
        if (this.props.parent.state.currentOptions) {
            selectedValues = this.props.parent.state.currentOptions
        } else {
            // selectedOptions = []
            selectedValues = field.getViewValue(this.props.model) || []
            // selectedOptions = field.getValueOptions(this.props.model)
        }


        return (
            <>
                {_.map(options, (option:Option, key)=>{

                    if (option.type === PopoverMenuItemType.SEPARATOR) {
                        return <PopoverMenuSeparator key={key} />
                    }

                    if (option.type === PopoverMenuItemType.HEADER) {
                        return <PopoverMenuHeader title={option.title} />
                    }

                    return <field.components.PopoverOption ref={(r:any)=>this.optionRef[key] = r}
                                                           key={option.isAllValuesOption ? 'all_values' : option.value}
                                                           option={option}
                                                           isHighlighted={highlightedOption && highlightedOption.value === option.value}
                                                           isSelected={selectedValues.includes(option.value)}
                                                           onClick={(e: React.MouseEvent)=>this.onClickOption(option, e)}/>
                })}
            </>
        );
    }
}
